// ── theme.js — цвета, слои и размеры для деталей интерфейса ──────────────────
// Детали из src/ui берут палитру из контекста (App кладёт туда THEMES[theme]),
// поэтому её не нужно передавать в каждую кнопку. Старый код по-прежнему
// пользуется своим C — переводим экраны на детали по одному.

import { createContext, useContext, useEffect, useState } from 'react';
import { THEMES } from '../themes';

export const ThemeContext = createContext(THEMES.light);

// Палитра текущей темы. Явно переданная (C={…}) важнее — для мест вне App.
export function usePalette(C) {
  const ctx = useContext(ThemeContext);
  return C || ctx;
}

// Слои: что над чем лежит. Один список вместо разбросанных 100/600/9999/10050.
export const Z = {
  sticky: 20, // шапка раздела
  floating: 80, // мини-плеер, плавающая карточка
  nav: 90, // нижняя панель и боковое меню
  stage: 5000, // игра на весь экран («Рой слов»): поверх навигации и мини-плеера, под окнами
  modal: 10000, // окна и листы снизу (новое окно — поверх прежнего: порядок в DOM)
  menu: 10050, // всплывающие меню (могут открываться из окна)
  toast: 10100, // сообщения «Отменить»
};

// Размеры нажимаемых мест (px). WCAG 2.2: не меньше 24; для пальца — 32 и больше.
export const TARGET = { min: 24, touch: 32, comfy: 44 };

// Телефон — меньше 768 px (как навигация приложения: нижняя панель).
export const PHONE_MAX = 767;

export function useMedia(query) {
  const get = () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : false);
  const [match, setMatch] = useState(get);
  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const m = window.matchMedia(query);
    const on = () => setMatch(m.matches);
    on();
    m.addEventListener ? m.addEventListener('change', on) : m.addListener(on);
    return () => (m.removeEventListener ? m.removeEventListener('change', on) : m.removeListener(on));
  }, [query]);
  return match;
}

export const usePhone = () => useMedia(`(max-width: ${PHONE_MAX}px)`);
// Сенсорный экран без мыши — нажимают пальцем.
export const useTouch = () => useMedia('(hover: none) and (pointer: coarse)');
